var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHugeiconsTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48814 11.556L12.0547 14.3205C13.0047 15.3443 13.4805 15.8565 13.9785 15.7313C14.4756 15.6068 14.6466 14.9333 14.9879 13.5855L16.8799 6.10953C17.4064 4.03353 17.6692 2.99628 17.085 2.48403C16.5007 1.97178 15.4882 2.35278 13.4631 3.11403L4.06919 6.64878C2.44944 7.25853 1.63956 7.56303 1.5881 8.08653C1.58204 8.13988 1.58204 8.19368 1.5881 8.24703C1.63798 8.77128 2.44627 9.07803 4.06444 9.69228C4.79673 9.97053 5.16327 10.11 5.4261 10.3763C5.45566 10.4063 5.48416 10.4373 5.5116 10.4693C5.75385 10.7543 5.85677 11.1293 6.06339 11.8763L6.45052 13.2765C6.65081 14.004 6.75135 14.3685 7.01498 14.418C7.2786 14.4675 7.50739 14.166 7.96577 13.5623L9.48814 11.556ZM9.48814 11.556L9.23718 11.3085C8.9506 11.025 8.80731 10.884 8.80731 10.7085C8.80731 10.533 8.94981 10.3913 9.23718 10.1085L12.0658 7.31553",
    stroke: "#A3A3A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeiconsTelegram);
export default __webpack_public_path__ + "static/media/hugeicons_telegram.503c4cf6caf3e505a8fa105b09384974.svg";
export { ForwardRef as ReactComponent };